module.exports = __webpack_public_path__ + "img/20.f23f75e6.png";